import { Injectable } from "@angular/core";
import { ENVIRONMENT } from "../../../config/index";

@Injectable()
export class LoggerService {
  constructor() {}

  public log(...objects: any[]) {
    this.log_real(console.log, objects);
  }

  public debug(...objects: any[]) {
    this.log_real(console.debug, objects);
  }

  public info(...objects: any[]) {
    this.log_real(console.info, objects);
  }

  public warning(...objects: any[]) {
    this.log_real(console.warn, objects);
  }

  public error(...objects: any[]) {
    this.log_real(console.error, objects);
  }

  protected async log_real(func: Function, objects: any[]) {
    const env = ENVIRONMENT;
    if (env !== "production") {
      func.apply(console, objects);
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/common/logger/logger.service.ts